module.exports = __webpack_public_path__ + "static/tracking-ec8bf1d89312a4be2b4ff47ed8d81d2c.svg";